import { gql } from '@apollo/client';
export const GET_ROWS_DATA_POSITION= gql`
mutation( $input:PositionUpdateInput!
)
{
    updateRowsPositions(input: $input)
{
    result
  }
    }`;